import { Component, QueryList, ViewChildren } from '@angular/core';
import { FiltersM, typesApex } from '../../../components/models';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from '../../../services/data/data.service';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { SegPresupuestalService } from '../../../services/segimiento-presupuestal/seg-presupuestal.service';
import { messages } from '../../funciones/mensajes';
import { firstValueFrom } from 'rxjs';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { companiesSegPresupuestal } from '../../../shared/catalogos';
import { detalleIndicadorEntity, evaluacionesAllEntity, gruposIndEntity, indicadorEntity, sucursalesEntity } from '../../../services/segimiento-presupuestal/Manual/entities';
import { Periodos } from '../funcionesFormuladorSeguimiento';
import { coloresSemaforos } from '../idsTabla';

@Component({
  selector: 'app-razones-financieras',
  templateUrl: './razones-financieras.component.html',
  styleUrl: './razones-financieras.component.css'
})
export class RazonesFinancierasComponent {
  public Filters = FiltersM;
  public tagInstitucion: number;
  // Propiedades para períodos
  public Periodos: any[] = [];
  public periodoSeleccionado: any = null;
  public escenarios: any[] = [];
  public escenariosShow: any[] = [];
  public escenarioSeleccionado;
  public sucursales: any[] = [];
  public consolidado: boolean = true;
  public sucursalSeleccionada;
  private institucionId = undefined;
  private templateId = undefined;
  private idBase: number;
  public consolidadoInd: boolean = true;
  public indicadores = []
  public dataIndicadores = [];
  public encSemaforos = [];
  public ordenSemaforos = [{nombre:'v+', color: '#72d54a'},{nombre:'v-', color: '#9ae600'}, {nombre: 'a+', color: '#ffd100'},
      {nombre:'a-', color: '#ffdf20'}, {nombre:'r+', color: '#ff495c'}, {nombre:'r-', color: '#ff6467'}];  
  private ordenSemaforosMap = this.ordenSemaforos.reduce((map, semaforo, index) => {
        map[semaforo.color] = index;
        return map;
      }, {});
  
  public reglasSemaforosMap = {};
  public visibleEncSem = true;
  public indSeleccionado;

  public vistaGraf:boolean = false;
  public dataGraf = [];
  public etiquetasGraf;
  public etiqueta: boolean = false;
  public changeLabel:boolean = true;
  public typeGraph = typesApex
  public tipoGraf = this.typeGraph.COMBO;
  public graficasLineales = []; 
  public grafAmp = {name: '', series: [], labels: []};
  public coloresGrafico: string[] = ['#00255c', '#018fbf', '#8ad3e6']; // azul Presupuesto, verde Real, rojo variacion

  @ViewChildren(GraficadorComponent)grafCmp!:QueryList<GraficadorComponent>;
  public subtituloGrafica:string = "";

  public modalOpen:boolean = false;
  public titModal: string;
  public subtitModal: string;
  public zonaAmp: number;
  

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    public cookies: CookieService,
    private excelService: ExcelService,
    private segPresupuestalService: SegPresupuestalService,
  ) {
    this.institucionId = this.cookies.get('idInstitucion');
    this.idBase = companiesSegPresupuestal.find(i => i.id == this.institucionId).idBack;
    this.personalizacion();
    this.initSucursales();
    this.initEscenarios();
  }

  private personalizacion(){
    this.tagInstitucion = companiesSegPresupuestal.find( i => i.id == this.institucionId).etiquetas;
  }

  private async initEscenarios() {
    try{
      let sucursalEntity: sucursalesEntity = {agrupadorId: this.idBase, tipoInstitucionId: 3};
      let res = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      this.escenarios = res.map(({ institucion, ...rest}) => ({
        name: institucion.split('|')[1],
        check: false,
        ...rest
      }))
      this.escenarios[0].check = true;
    }catch(e){
      console.warn(e);
      messages.errorMessageGraph(e.error);
    }
  }

  private async initSucursales() {
    try{
      let res = [];
      let sucursalEntity: sucursalesEntity =  {id: this.idBase};
      const matriz = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      this.templateId = matriz[0].plantillaId;
      let consolidado = {name: 'Consolidado', consolidado: true, check: true, id: this.idBase};
      this.sucursales.push(consolidado)
      sucursalEntity = {agrupadorId: this.idBase, tipoInstitucionId: 5};
      res = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      const resFiltro = res.filter(i => ((i.acronimo).toLowerCase()).includes('real'));
      const resEsce = res.filter(i => ((i.acronimo).toLowerCase()).includes('presupuesto'));
      const s = new Set();
      const sucur = resFiltro.map(({ institucion, ...rest}) => ({
        name: institucion.split('|')[1],
        consolidado: false,
        check: false,
        ...rest,
      })).filter( i => {
        if(s.has(i.name))
          return false;
        s.add(i.name);
        return true;
      });
      this.sucursales.push(... sucur);
      for(const suc of this.sucursales){
        if(suc.consolidado){
          suc['instEsce'] = this.escenarios;
        }else{
          const nombreSucursal = suc.name.trim().toLowerCase();

          suc.instEsce = resEsce.filter(item =>
            item.institucion.toLowerCase().includes(nombreSucursal)
          );
        }        
      }
      this.sucursalSeleccionada = this.sucursales[0];
      this.initPeriodos();
    }catch(e){
      console.warn(e);
      messages.errorMessageGraph(e.error);
    }
  }

  private async initPeriodos() {
    try{
      let evaluaciones: evaluacionesAllEntity = {plantillaId: this.templateId, institucionId: this.sucursalSeleccionada.id};
      const evaReal = await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluaciones));
      const info = Periodos.evaluacionesPresupuestoReal(evaReal, []);
      this.Periodos = info.periodos;
      this.periodoSeleccionado = info.perSeleccionado;
      evaluaciones = {plantillaId: this.templateId, periodo: this.periodoSeleccionado.periodo};
      const escenarioDis =  await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluaciones));
      this.escenariosShow = escenarioDis.filter(e => e.institucionId !== this.sucursalSeleccionada.id && e.institucion_entity.agrupadorId === this.sucursalSeleccionada.id)
        .map((e, i) => {
          return {
            name: e.institucion_entity.institucion.split(' | ')[1],
            check: i===0,
            idPresupuesto: e.id,
            ...e.institucion_entity
          }
        });
      this.escenarioSeleccionado = this.escenariosShow[0];
      this.initIndicadores();
    }catch(e){
      console.warn(e);
      messages.errorMessageGraph(e.error);
    }
  }

  private async initIndicadores(){
    try{
      this.dataIndicadores = [];
      if(!this.templateId){this.dataIndicadores = []; return;}
      let idModulo = 1;
      let grupoEntity: gruposIndEntity = {plantillaId: this.templateId, moduloId: idModulo};
      const grupos = await firstValueFrom(this.segPresupuestalService.getgrupoInd(grupoEntity));
      let indiEntity: indicadorEntity = {plantillaId: this.templateId};
      const indi = await firstValueFrom(this.segPresupuestalService.getIndicadoresPropiedades(indiEntity))
      let indiValor: detalleIndicadorEntity = {idEvaluacion: this.periodoSeleccionado.idReal};
      const dataReal = await firstValueFrom(this.segPresupuestalService.getIndicadoresValor(indiValor));
      const idEvaEsce = this.escenariosShow.find(e => e.check);
      indiValor = {idEvaluacion: idEvaEsce.idPresupuesto}
      const dataPresupuesto = await firstValueFrom(this.segPresupuestalService.getIndicadoresValor(indiValor));

      this.indicadores = grupos.map(({grupoIndicador, ...rest})=>({
        name: grupoIndicador,
        check: true,
        ...rest
      }))
      
      for(const ind of this.indicadores){
        const indgrupo = await firstValueFrom(this.segPresupuestalService.getindicadorGrupo(ind.id));
        this.dataIndicadores.push({grupoid: ind.id,nombre: ind.name, presupuesto: 0, real: 0, variacion: 0, paramMeta: 0, formula: '', semaforo: '', nivel: 1, check:ind.check, expandido: true});
        for(const g of indgrupo){
          const indicador = indi.find(d => d.id === g.indicadorId);
          const valorReal = dataReal.data.detalleEvaluacionIndicadors.find( v => v.idIndicador === indicador.id);
          const valorPresupuesto = dataPresupuesto.data.detalleEvaluacionIndicadors.find( v => v.idIndicador === indicador.id);
          let v = !isNaN( valorPresupuesto.valor - valorReal.valor) ? Number(( valorPresupuesto.valor - valorReal.valor).toFixed(2)) : 0;
          let semaforos = this.convertirSemaforos(indicador.semaforos);
          this.reglasSemaforosMap = semaforos.reglasMap;
          this.dataIndicadores.push({
            grupoid: ind.id,
            id: indicador.id,
            code: indicador.code,
            nombre: indicador.indicador, 
            presupuesto: Number((valorPresupuesto.valor).toFixed(2)), 
            real: Number((valorReal.valor).toFixed(2)), 
            semaforoReal: valorReal.textoSemaforo,
            semaforoPresupuesto: valorPresupuesto.textoSemaforo,
            colorReal: coloresSemaforos.color(valorReal.textoSemaforo),
            colorPres: coloresSemaforos.color(valorPresupuesto.textoSemaforo),
            variacion: v, 
            paramMeta: 0, 
            formula: indicador.comentario, 
            semaforo: semaforos.reglasMap,
            nivel: 2,
            expandido: true});
        }
      }
      this.indSeleccionado = this.dataIndicadores[1];
      this.historicoInd();
    }catch(e){
      console.warn(e);
      messages.errorMessageGraph(e.error)
    }
  }
  private convertirSemaforos(semaforos){
    // Ordenar según el orden definido
    semaforos.sort((a, b) =>
      this.ordenSemaforosMap[a.color] - this.ordenSemaforosMap[b.color]
    );
    const reglasMap = {};
    for (let i = 0; i < semaforos.length; i++) {
      const actual = semaforos[i];
      // Registrar el color para conocer los semáforos utilizados por la plantilla
      if (!this.encSemaforos.includes(actual.color)) {
        this.encSemaforos.push(actual.color);
      }
      // Primer semáforo
      if (i === 0) {
        actual.regla = `${actual.opInclusive ? '>=' : '>'} ${actual.valor}`;
      } else {
        const anterior = semaforos[i - 1];
        // Último semáforo
        if (i === semaforos.length - 1) {
          actual.regla = `${anterior.opInclusive ? '<' : '<='} ${anterior.valor}`;
        } else {
          // Intermedios
          actual.regla =
            `${actual.opInclusive ? '>=' : '>'} ${actual.valor} ` +
            `y ` +
            `${anterior.opInclusive ? '<' : '<='} ${anterior.valor}`;
        }
      }
      // Agrupar reglas por color
      if (!reglasMap[actual.color]) {
        reglasMap[actual.color] = [];
      }
      reglasMap[actual.color].push(actual.regla);
    }
    return {semaforos, reglasMap};
  }

  public async cambioPeriodo(per: any) {
    if (!per) return;
    
    // Si el objeto tiene propiedades 'mes' y 'anio', es un mes
    if (per.mes && per.anio) {
      // Actualizar solo el mes seleccionado
      this.Periodos.forEach(p => {
        if (p.series) {
          p.series.forEach(mes => {
            mes.check = (mes.mes === per.mes && mes.anio === per.anio);
          });
        }
      });
      this.periodoSeleccionado = per;
      const evaluaciones = {plantillaId: this.templateId, periodo: this.periodoSeleccionado.periodo};
      const escenarioDis =  await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluaciones));
      const eseneriosAMost = escenarioDis.filter(e => e.institucionId !== this.sucursalSeleccionada.id && e.institucion_entity.agrupadorId === this.sucursalSeleccionada.id)
      .map((e, i) => {
        return {
          name: e.institucion_entity.institucion.split(' | ')[1],
          check: i===0,
          idPresupuesto: e.id,
          ...e.institucion_entity
        }
      });

      const iguales = eseneriosAMost.length === this.escenariosShow.length &&
        eseneriosAMost.every((item, i) => item.name === this.escenariosShow[i].name);
      if(!iguales){
        this.escenariosShow = eseneriosAMost;
      }else{
        this.escenariosShow.forEach( e => {
          const es = eseneriosAMost.find(ee => ee.name === e.name);
          e.idPresupuesto = es.idPresupuesto ?? e.idPresupuesto;
        });
      }
      this.escenarioSeleccionado = this.escenariosShow.find(e => e.check);
      this.initIndicadores();
    }
  }

  public escenarioChange(escClick: any) {
    if (!escClick || !escClick.name) return;

    this.escenariosShow.forEach(e => e.check = (e.name === escClick.name));
    const seleccionado = this.escenariosShow.find(e => e.check);
    this.escenarioSeleccionado = seleccionado;
    this.initIndicadores();
  }

  public async sucursalChange(sucClick: any) {
    for (const suc of this.sucursales) {
      if (suc.name === sucClick.name) {
        suc.check = true;
      }else{
        suc.check = false;
      }
    }

    if (sucClick.name === 'Consolidado') {
      this.consolidado = true;
    }else{
      this.consolidado = false;
    }
    this.sucursalSeleccionada = sucClick;
    this.initPeriodos();
  }

  public filtroIndicadores(ind){
    if(ind === "consolidado"){
      this.consolidadoInd = !this.consolidadoInd;
      if(this.consolidadoInd){
        for(const indi of this.indicadores){
          indi.check = true;
        }
        for(const i of this.dataIndicadores){
          if(i.nivel == 1) i.check = true; 
          i.expandido = true;          
        }
      }
    }
    for(const indi of this.indicadores){
      if(ind.name === indi.name){
        indi.check = !indi.check;
      }
    }
    const e = ind.check;
    for(const i of this.dataIndicadores){
      if(i.grupoid == ind.id){
        if(i.nivel == 1) i.check = e; 
        i.expandido = e;
      }
    }
  }

  public resetFilters(){
    const ultimoAnio = this.Periodos[this.Periodos.length - 1];

    if (ultimoAnio) {
      this.periodoSeleccionado = ultimoAnio.series[ultimoAnio.series.length - 1];
      this.periodoSeleccionado.check = true;
    }

    for (const suc of this.sucursales) {
      suc.check = false;
    }
    this.consolidado = true;
    this.consolidadoInd = true;
    this.sucursales[0].check = true;
    this.sucursalSeleccionada = this.sucursales[0];
    for (const ind of this.indicadores) {
      ind.check = true;
    }
    for(const i of this.dataIndicadores){
      if(i.nivel == 1) i.check = true; 
      i.expandido = true;          
    }
    this.vistaGraf = false;
    this.tipoGraf = this.typeGraph.COMBO;
    this.etiqueta = false;
    this.visibleEncSem = false;
    this.initPeriodos();
  }

  public exportarTabla(){
    var titulos = [], alineacion = [], formato = [], aux = [], data_excel = [];
    var nombreArch = '', titHoja = '';
    alineacion = [Aligment.LEFT,Aligment.RIGHT,Aligment.RIGHT,Aligment.RIGHT];
    formato = [FormatText.TEXT, FormatText.PORCENTAJE2, FormatText.PORCENTAJE2, FormatText.PORCENTAJE2]
    titulos = [
      this.translate.instant('segPresupuestal.razonesFinancieras.titTab1'),
      this.translate.instant('segPresupuestal.razonesFinancieras.titTab2'),
      this.translate.instant('segPresupuestal.razonesFinancieras.titTab3'),
      this.translate.instant('segPresupuestal.razonesFinancieras.titTab4'),
    ];
    titHoja = `${this.translate.instant('segPresupuestal.razonesFinancieras.sucursal'+this.tagInstitucion)} ${this.sucursalSeleccionada.name} ${this.periodoSeleccionado.nombre} | ${this.escenarioSeleccionado.name}`;
    nombreArch = `${this.translate.instant('segPresupuestal.razonesFinancieras.sucursal'+this.tagInstitucion)} ${this.sucursalSeleccionada.name} ${this.periodoSeleccionado.nombre}`;
    for(const d of this.dataIndicadores){
      aux = [];
      aux.push(d.nombre);
      aux.push(d.presupuesto/100);
      aux.push(d.real/100);
      aux.push(d.variacion/100);
      data_excel.push(aux);
    }
    this.excelService.generateExcel(titHoja,titulos,data_excel,nombreArch,alineacion,formato);
  }

  public async verGraficas(){
    this.vistaGraf = true;
    this.graficasLineales = [];
    let auxFinal = [];
    const idEvaEsce = this.escenariosShow.find(e => e.check)
    const evaluacionesAn: evaluacionesAllEntity = {plantillaId: this.templateId, institucionId: idEvaEsce.id};
    const escenarioDisAn =  await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluacionesAn));
    const periodosEsce = escenarioDisAn.slice(0,escenarioDisAn.findIndex(i => i.periodo === this.periodoSeleccionado.periodo)+1);
    const periodos = (this.Periodos.find(a => a.series.find(m => m.check))).series;
    const indiceCheck = periodos.findIndex(p => p.check);
    const ultimosPeriodos = indiceCheck === -1
      ? []
      : periodos.slice(0, indiceCheck + 1); 
    var etiquetas = ultimosPeriodos.map( p => { return `${this.translate.instant('filtros.'+p.mes)} ${p.anio}`; });    
    let indiValor: detalleIndicadorEntity;
    for(var i = 0; i < this.dataIndicadores.length; i++){
      let auxData;
      let presupuestos: number[] = [];
      let reales: number[] = [];
      let metas: number[] = [];
      if(this.dataIndicadores[i].nivel !== 1){
        for(let j = 0; j < ultimosPeriodos.length; j++){
          indiValor = {idIndicador: this.dataIndicadores[i].id, idEvaluacion: ultimosPeriodos[j].idReal};
          const real = await firstValueFrom(this.segPresupuestalService.getIndicadoresValor(indiValor));
          const vreal = Number(real.data.detalleEvaluacionIndicadors[0].valor.toFixed(2))
          reales.push(vreal);
          indiValor = {idIndicador: this.dataIndicadores[i].id, idEvaluacion: periodosEsce[j].id}
          const pres = await firstValueFrom(this.segPresupuestalService.getIndicadoresValor(indiValor));
          const vpres = Number(pres.data.detalleEvaluacionIndicadors[0].valor.toFixed(2));
          presupuestos.push(vpres);
          const vVariacion = !isNaN( vpres - vreal ) ? Number((  vpres - vreal ).toFixed(2)) : 0;
          metas.push(vVariacion);
          auxData = [
            {name: 'Variación', data: metas},
            {name: 'Presupuesto', data: presupuestos},
            {name: 'Ejecutado', data: reales}
          ]
        }   
        auxFinal.push({name: this.dataIndicadores[i].nombre, series: auxData, labels: etiquetas, check: true});     
        if(auxFinal.length > 3){
          this.graficasLineales = auxFinal
        }     

      }
    }    
    // this.graficasLineales = auxFinal;
  }
  public quitarGraf(ind){
    this.graficasLineales.find(i => i.name === ind.name).check = false;
    this.dataIndicadores.find(i => i.nombre === ind.name).verGraf = false;
  }

  public indSelect(ind){
    this.indSeleccionado = ind;
    this.historicoInd();
  }

  private async historicoInd(){
    this.dataGraf = [];
    const idEvaEsce = this.escenariosShow.find(e => e.check)
    const evaluacionesAn: evaluacionesAllEntity = {plantillaId: this.templateId, institucionId: idEvaEsce.id};
    const escenarioDisAn =  await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluacionesAn));
    const periodosEsce = escenarioDisAn.slice(0,escenarioDisAn.findIndex(i => i.periodo === this.periodoSeleccionado.periodo)+1);
    const periodos = (this.Periodos.find(a => a.series.find(m => m.check))).series;
    const indiceCheck = periodos.findIndex(p => p.check);
    const ultimosPeriodos = indiceCheck === -1
      ? []
      : periodos.slice(0, indiceCheck + 1);
    this.etiquetasGraf = ultimosPeriodos.map( p => { return `${this.translate.instant('filtros.'+p.mes)} ${p.anio}`; });

    // Inicializar arrays para los 12 meses
    let presupuestos: number[] = [];
    let reales: number[] = [];
    let metas: number[] = [];
    try{
      let indiValor: detalleIndicadorEntity;
      for(let i = 0; i < ultimosPeriodos.length; i++){
        indiValor = {idIndicador: this.indSeleccionado.id, idEvaluacion: ultimosPeriodos[i].idReal};
        const real = await firstValueFrom(this.segPresupuestalService.getIndicadoresValor(indiValor));
        const vreal = Number(real.data.detalleEvaluacionIndicadors[0].valor.toFixed(2))
        reales.push(vreal);
        indiValor = {idIndicador: this.indSeleccionado.id, idEvaluacion: periodosEsce[i].id}
        const pres = await firstValueFrom(this.segPresupuestalService.getIndicadoresValor(indiValor));
        const vpres = Number(pres.data.detalleEvaluacionIndicadors[0].valor.toFixed(2));
        presupuestos.push(vpres);
        const vVariacion = !isNaN( vpres - vreal ) ? Number((  vpres - vreal ).toFixed(2)) : 0
        metas.push(vVariacion);
      }
      this.dataGraf = [
        {
          name: 'Variación',
          data: metas
        },
        {
          name: 'Presupuesto',
          data: presupuestos
        },
        {
          name: 'Ejecutado',
          data: reales
        },      
      ]
    }catch(e){
      console.warn(e);
      messages.errorMessageGraph(e.error);
    }    
  }
  public cambiarTipoGrafica(type){
    this.tipoGraf = type;
  }
  public ampliarGraf(zona, graf?){
    this.modalOpen = true; 
    this.zonaAmp = zona;
    if(zona === 0){
      this.titModal = `${this.translate.instant('segPresupuestal.razonesFinancieras.evolucion')} ${this.indSeleccionado.nombre}`;
      this.subtitModal = `${this.periodoSeleccionado.nombre} | ${this.escenarioSeleccionado.name}`;
    }else{
      this.titModal = graf.name;
      this.subtitModal = this.periodoSeleccionado.nombre
      this.grafAmp.series = graf.series;
      this.grafAmp.labels = graf.labels;
      this.grafAmp.name = graf.name;
    }
  }
  public exportarGrafica(zona, graf?){
    if(zona === 0){
      this.subtituloGrafica = `${this.translate.instant('segPresupuestal.razonesFinancieras.evolucion')} ${this.indSeleccionado.nombre} ${this.periodoSeleccionado.nombre} | ${this.escenarioSeleccionado.name}`
    }else{
      this.subtituloGrafica = graf ? graf.name : this.grafAmp.name;
    }
    var name = { 
      titulo: this.translate.instant('menu.'+this.dataService.subModuleSelect),
      subtitulo: this.subtituloGrafica,
      nombreArch: this.translate.instant('menu.'+this.dataService.subModuleSelect)
    }
    
    const comp = this.grafCmp.find(g => g.zona === zona);
    comp.exportImg(zona,name)
  }
  public numPerSelect(){
    var selecc = 0;
    for(const ind of this.indicadores){
      if(ind.check){
        selecc++;
      }
    }
    if(selecc > 1)
      return true;
    return false;
  }
  public toggleExpansion(ind){
    const e = !ind.expandido
    for(const d of this.dataIndicadores){
      if(d.grupoid === ind.grupoid){
        d.expandido = e;
      }
    }
  }
  public mostrarSemaforos(){
    this.visibleEncSem = !this.visibleEncSem;
  }
  public getReglaSemaforo(arreglo, semaforo){
    return arreglo
      .filter(s => s.color === semaforo)
      .map(s => s.regla)
      .join('<br>');
  }
  public getColorSem(txt){
    return coloresSemaforos.color(txt)
  }
}
